export default __webpack_public_path__ + "static/media/equitel.9e180c96.jpg";